export function proxy(getter) {
    return new Proxy({}, {
        get: function (_, key) { return getter(key); },
    });
}
//# sourceMappingURL=proxy.js.map